import { ActionMethod, CardType, CmsProperty } from '../../api/models/Shared.types';
import { CmsRibbon } from '../../components/cms/CmsRibbon';
import { CardDataSource } from './CardDataSource';
import { CardSizeInfo } from './CardSizeInfo';
import { EpgUtil, ISortedSeasons } from '../utility/EpgUtil';
import { LLDataSource } from './LLDataSource';
import { Backend } from '../../api/Backend';
import { IChannelV5 } from '../../api/models/AndromeTV.types';
import { ChannelModel } from '../../api/EpgApi.types';

/**
 * @property {CardDataSource[]} cards
 * @property {CardSizeInfo} sizeInfo
 * @property {boolean} hasNextPage
 */
export class EpgEpisodeRibbonDataSource extends LLDataSource {
  private sortedSeason: ISortedSeasons;
  private channels: IChannelV5[];
  private properties: CmsProperty[];
  public sizeInfo: CardSizeInfo;

  constructor(backend: Backend, sortedSeason: ISortedSeasons, channels: IChannelV5[], properties: CmsProperty[]) {
    super(backend);
    this.sortedSeason = sortedSeason;
    this.channels = channels;
    this.properties = properties;

    this.sizeInfo = new CardSizeInfo();
  }

  _fetchPage() {
    return new Promise(resolve => {
      if (this.items.length > 0) {
        resolve(this);
      }
      this.items = [];
      const cards = this.sortedSeason.sortedPrograms.map(program => ({
        asset: EpgUtil.programToRibbon2Detail(program.program, [program.season]),
        method: ActionMethod.DETAIL,
        channels: EpgUtil.schedulesToRibbon2Channels([program.schedule]),
      }));
      this.sizeInfo.updateWithContainer(
        {
          type: CardType.Landscape,
          nextPage: false,
          items: cards,
        },
        this.properties
      );
      const convertToChannelModel = this.channels.map(el => new ChannelModel(el));
      const newCards = cards.map(
        card => new CardDataSource(this.backend, card, this.sizeInfo, this.properties, convertToChannelModel)
      );
      this.items = this.items.concat(newCards);
      this.hasNextPage = false;
      resolve(this);
    });
  }

  totalHeight() {
    return this.sizeInfo.height;
  }

  set initialSizeInfo(szi: CardSizeInfo) {
    this.sizeInfo = szi;
  }

  override componentDescription() {
    return {
      focusable: true,
      type: CmsRibbon,
      data: this,
      h: this.totalHeight(),
    };
  }
}
